import React from "react";
import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";
import Modal from "./Modal";

import { styles } from "../styles";
import { services } from "../constants";
import { SectionWrapper } from "../hoc";
import { fadeIn, textVariant } from "../utils/motion";

const ServiceCard = ({ index, title, icon, link, description }) => (
  <Tilt className="xs:w-[250px] w-full">
    <motion.div
      variants={fadeIn("right", "spring", index * 0.5, 0.75)}
      className="w-full Pastel bg-gradient-to-tr from-violet-500 to-orange-300 p-[1px] rounded-[20px] shadow-card"
    >
      <a
        href={link}
        target="_blank"
        options={{
          max: 45,
          scale: 1,
          speed: 450,
        }}
        className="bg-tertiary rounded-[20px] py-5 px-6 min-h-[280px] flex justify-evenly items-center flex-col"
      >
        <img
          src={icon}
          alt="web-dev"
          className="w-14 border-2 rounded-full bg-white border-double h-14"
        />

        <h3 className="mt-4 text-white text-lg font-semibold text-center">
          {title}
        </h3>
        <p className="mt-2 text-sm text-center">{description}</p>
      </a>
    </motion.div>
  </Tilt>
);

const Usecases = () => {
  return (
    <>
      <motion.div variants={textVariant()}>
        <h2 className={styles.sectionHeadText}>Use Cases</h2>
      </motion.div>

      <motion.p
        variants={fadeIn("", "", 0.1, 1)}
        className="mt-4 text-secondary text-[17px] max-w-3xl leading-[30px]"
      >
        Transforming Ideas into Actionable Services<span> | </span>
        Using Our Studio
      </motion.p>

      <div className="mt-16 flex items-center justify-center flex-wrap gap-10">
        {services.map((service, index) => (
          <ServiceCard
            key={service.title}
            index={index}
            description={service.description}
            link={service.link}
            {...service}
          />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Usecases, "usecases");
